import { ComponentPropsWithoutRef, memo, useMemo } from 'react';

type HighlightTextProps = ComponentPropsWithoutRef<'span'> & {
  text: string;
  highlight: string;
};

const HighlightTextRaw = ({
  text,
  highlight,
  ...props
}: HighlightTextProps) => {
  const parts = useMemo(() => {
    if (!highlight) return [{ text, bold: false }];

    const escaped = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    return text.split(regex).map((part) => ({
      text: part,
      bold: regex.test(part) && ((regex.lastIndex = 0), true),
    }));
  }, [text, highlight]);

  return (
    <span {...props}>
      {parts.map((part, i) =>
        part.bold ? <strong key={i}>{part.text}</strong> : part.text
      )}
    </span>
  );
};

export const HighlightText = memo(HighlightTextRaw);
